/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Create_For_OrderInputs */

const vi_customer_create_for_order = /** @type {(inputs: Customer_Create_For_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo khách hàng mới và tự động chọn cho đơn hàng`)
};

/**

* @param {Customer_Create_For_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_create_for_order = /** @type {((inputs?: Customer_Create_For_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Create_For_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_create_for_order(inputs)
});